import React from 'react';
import css from './SaveData.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import android_studio from "../../../assets/images/extra/android_studio.png";
import java from "../../../assets/images/extra/java-coffee-cup-logo.png";
import sqlite from "../../../assets/images/extra/sqlite.png";
import SaveDataMocket from "../../../assets/images/projectsImage/SaveDataMocket.jpg";

const SaveData: React.FC = () => (
    <div className={css.project} id="save_data">
        <img src={SaveDataMocket} alt=""/>

        <div className={css.projectInformationContainer}>

            <div className={css.info}>
                <Chip label="May 2018 - Jun. 2018" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="May 2018 - Jun. 2018" variant="outlined" size='small'/>
            </div>

            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Save Data</h3>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>It is a backup application that automatically synchronize and save data from
                your smartphone into your computer.</p>

            <div className={css.learnMoreLink}>
                <p>Source code: <a className={css.link}
                            href='https://github.com/adhess/save_Data'
                            rel="noopener noreferrer"
                            target="_blank">https://github.com/adhess/save_Data</a>
                </p>
            </div>

            <h5 className={css.textSectionInfo}>Tasks:</h5>
            <ul className={css.tasks}>
                <li>
                    Designed and developed the android application backed up by a java
                    server.
                </li>
            </ul>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="Android Studio">
                    <img src={android_studio} alt=''/>
                </Tooltip>
                <Tooltip title="Java">
                    <img src={java} alt=''/>
                </Tooltip>
                <Tooltip title="Sqlite database">
                    <img src={sqlite} alt=''/>
                </Tooltip>
            </div>
        </div>
    </div>
);

export default SaveData;
